import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cleanString'
})
export class CleanStringPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';

    // Step 1: Decode &amp; to &
    let decoded = value.replace(/&amp;/g, '&');

    // Step 2: Convert numeric character references to actual characters
    decoded = decoded.replace(/&#(\d+);?/g, (_, code) =>
      String.fromCharCode(parseInt(code, 10))
    );

    // Step 3: Remove unwanted characters (newline, tab, bullet, etc.)
    decoded = decoded.replace(/[\n\t•]/g, ' ');

    // Step 4: Normalize spaces
    return decoded.replace(/\s+/g, ' ').trim();
  }
}
